import { useState, useEffect } from 'react';

const UseScroll = () => {
  const [move, setMove] = useState(false);
  const [scrollDown, setScrollDown] = useState(false);

  useEffect(() => {
    let prevScrollY = 0;
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const isScrollDown = currentScrollY > prevScrollY;

      setScrollDown(() => {
        return currentScrollY > 15 ? isScrollDown : false;
      });

      if (currentScrollY > 15 && !move) {
        setMove(true);
      } else if (currentScrollY <= 15 && move) {
        setMove(false);
      }
      prevScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [move]);

  return [move, scrollDown];
};

export default UseScroll;
